<template>
    <div>
        <v-icon>{{ icon }}</v-icon>
        <!-- <v-icon @click="setNetworkConnection" :class="{'opacity-high':connected}">{{ icon }}</v-icon> -->

        <v-bottom-sheet v-model="notify" inset>
            <v-sheet>
                <v-row align="center" align-content="space-around">
                    <v-col cols="3" class="text-center">
                        <v-icon size="3rem">$vuetify.icons.network_warn</v-icon>
                    </v-col>
                    <v-col cols="9">
                        <h5>Working in Off-Line mode may affect some app functionality..</h5>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="auto" class="text-center">
                        <v-btn rounded class="px-5" @click="notify = false">
                            dismiss
                            <v-icon right>$vuetify.icons.close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import {
        mapActions,
        mapGetters
    } from "vuex";

    export default {
        name: "NetworkIndicator",

        computed: {
            ...mapGetters("appshell", ["connected"]),

            icon() {
                return this.connected ? `$vuetify.icons.network_on` : `$vuetify.icons.network_off`;
            },
        },

        methods: {
            ...mapActions("appshell", ["updateNetworkStatus"]),


            setNetworkConnection() {
                this.updateNetworkStatus(!this.connected);
            }
        },

        watch: {
            connected(newValue, oldValue) {
                this.notify = !newValue;
            }
        },

        data: () => ({
            notify: false
        }),
    }
</script>

<style lang="scss" scoped>

</style>